import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { DRAWER_MESSAGES } from '../../LoanEditorCustomFormDrawer.constants';
import EntitySelector from '../EntitySelector';

import { BorrowerSelectorTestIds } from './BorrowerSelector.testIds';

const BorrowerSelector = ({ borrowers, disabled = false, selectedBorrowerId = null, onSelect }) => (
  <EntitySelector
    dataTestId={BorrowerSelectorTestIds.BORROWER_SELECT}
    emptyText={DRAWER_MESSAGES.NO_BORROWERS_AVAILABLE}
    helperText={DRAWER_MESSAGES.BORROWER_SELECTOR_HELPER}
    isDisabled={disabled}
    label={DRAWER_MESSAGES.BORROWER_SELECTOR_LABEL}
    name="loanEditorCustomFormBorrowerSelector"
    options={borrowers}
    placeholder={DRAWER_MESSAGES.BORROWER_SELECTOR_PLACEHOLDER}
    selectedId={selectedBorrowerId}
    onSelect={onSelect}
  />
);

BorrowerSelector.propTypes = {
  borrowers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string,
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedBorrowerId: PropTypes.string,
};

export default memo(BorrowerSelector);
